import { render, staticRenderFns } from "./home-commodity.vue?vue&type=template&id=956254ba&scoped=true"
import script from "./home-commodity.vue?vue&type=script&lang=js"
export * from "./home-commodity.vue?vue&type=script&lang=js"
import style0 from "./home-commodity.vue?vue&type=style&index=0&id=956254ba&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956254ba",
  null
  
)

export default component.exports